// Group GROUP 15. Advanced Inversion/Emphasis
// Complete data from "Grammar 90 Groups (GPT5) 5 Examples Each.txt"

export const group15Data = {
  "id": "group_15",
  "title": {
    "tc": "倒裝/強調變體",
    "sc": "倒装/强调变体",
    "en": "Advanced Inversion/Emphasis"
  },
  "subtitle": {
    "tc": "Advanced Inversion/Emphasis",
    "sc": "Advanced Inversion/Emphasis",
    "en": "Advanced Inversion/Emphasis"
  },
  "icon": "🔄",
  "difficulty": "advanced",
  "color": "from-violet-500 to-violet-600",
  "topics": [
    {
      "id": "not_until_inversion",
      "title": {
        "tc": "Not until… 倒裝",
        "sc": "Not until… 倒装",
        "en": "Not until + inversion"
      },
      "description": {
        "tc": "學習 Not until 倒裝結構的用法",
        "sc": "学习 Not until 倒装结构的用法",
        "en": "Learn Not until inversion structures"
      },
      "icon": "⏰",
      "difficulty": "advanced",
      "examples": [
        {
          "id": "not_until_1",
          "sentence": "Not until midnight did he finish.",
          "analysis": "Not until midnight (M) did (Aux) he (S) finish (V).",
          "translation": {
            "tc": "直到午夜他才完成。",
            "sc": "直到午夜他才完成。",
            "en": "Not until midnight did he finish."
          }
        },
        {
          "id": "not_until_2",
          "sentence": "Not until I asked did she answer.",
          "analysis": "Not until I asked (M) did (Aux) she (S) answer (V).",
          "translation": {
            "tc": "直到我問她才回答。",
            "sc": "直到我问她才回答。",
            "en": "Not until I asked did she answer."
          }
        },
        {
          "id": "not_until_3",
          "sentence": "Not until then did we understand.",
          "analysis": "Not until then (M) did (Aux) we (S) understand (V).",
          "translation": {
            "tc": "直到那時我們才理解。",
            "sc": "直到那时我们才理解。",
            "en": "Not until then did we understand."
          }
        },
        {
          "id": "not_until_4",
          "sentence": "Not until much later did it make sense.",
          "analysis": "Not until much later (M) did (Aux) it (S) make (V) sense (O).",
          "translation": {
            "tc": "直到很久以後才有意義。",
            "sc": "直到很久以后才有意义。",
            "en": "Not until much later did it make sense."
          }
        },
        {
          "id": "not_until_5",
          "sentence": "Not until the end did they agree.",
          "analysis": "Not until the end (M) did (Aux) they (S) agree (V).",
          "translation": {
            "tc": "直到最後他們才同意。",
            "sc": "直到最后他们才同意。",
            "en": "Not until the end did they agree."
          }
        }
      ],
      "teachingNotes": {
        "tc": "要點：Not until + 前置狀語 → 主句倒裝（助動詞/BE 置前）。",
        "sc": "要点：Not until + 前置状语 → 主句倒装（助动词/BE 置前）。",
        "en": "Key points: Not until + fronted adverbial → main clause inversion (auxiliary/BE fronted)."
      }
    }
  ]
};
